<template>
  <div>
    <div class="loading" v-if="isLoading">
      <div>
        <img src="/interview/static/img/loading.gif">
        <p>Loading...</p>
      </div>
    </div>
    <Dashboard></Dashboard>
    <!-- 캠페인 상태 선택, 검색 -->
    <div class="topBar">
      <div class="selectWrap">
        <select class="selectBox" v-model="selected">
          <option disabled value="">Please select one</option>
          <option v-for="(type, n) in status" :key="n">{{type}}</option>
        </select>
        <span class="dataCnt">조회건수 : {{totalCnt}} 건</span>
      </div>
      <div class="searchWrap">
        <v-icon class="searchIcon">search</v-icon>
        <input :value="lastSearchKey" type="text" placeholder="검색어 입력" autocomplete="on"
          @change="updateSearchKey" @keyup.enter="updateSearchKey" class="searchInput">
      </div>
    </div>
    <!-- 캠페인 리스트 출력 -->
    <div class="tableWrapper">
      <table class="responsive_list">
        <thead class="table_header">
          <tr>
            <!-- <th> -> 한개의 컴포넌트 반복 -->
            <HeaderComp v-for="(value, index) in values"
              :key="index"
              :custKnd="cust_knd"
              :isSorted="isSorted"
              :index="index"
              :orderType="listOrderType"
              :setSortOption="setSortOption"
              :text="text[index]"
              :value="value"
            ></HeaderComp>
          </tr>
        </thead>
        <!-- 각 캠페인 정보 보여주는 tr 컴포넌트 -->
        <Result v-for="(campaign, index) in filteredCampaign"
          :key="index"
          class="resultView"
          :campaign="campaign"
          :campaignClick="campaignClick"
          :custKnd="cust_knd"
          :class="[index % 2 === 1 ? 'odd' : '']"></Result>
      </table>
      <div class="noData" v-show="isShow">데이터가 없습니다.</div>
      <div class="paginationWrap">
        <Pagination
        :currentPage="currentPage"
        :totalPageNum="totalPageNum"
        @pageChange="pageChange"></Pagination>
      </div>
    </div>
    <!-- 캠페인 code 확인 컴포넌트-->
  </div>
</template>
  
<script>
  import { mapMutations, mapGetters, mapState } from 'vuex'
  import { isLogin, checkCampaignYmd, checkUser, statusText } from '@/assets/func'

  import Result from './Result'
  import HeaderComp from './HeaderComp'
  import Dashboard from '@/components/dashboard/Dashboard'
  import Pagination from '@/components/pagination/Pagination'

  export default {
    name: 'resultList',
    data () {
      return {
        isLoading: false,
        isOpen: false,
        noData: false,
        selected_cam: {},
        status: [
          '전체',
          '진행',
          '홀딩',
          '완료',
          '중간정산'
        ],
        text: [ // th 컴포넌트에서 출력할 텍스트
          '상태',
          '시작일',
          '캠페인명',
          '시작일',
          '종료일',
          '광고주',
          '에이전시',
          '렙사'
        ],
        totalCnt: 0,
        user: '',
        values: [ // 각 th컴포넌트의 value - 리스트 정렬에 사용
          'status',
          'campaign_fr_ymd',
          'campaign_nm',
          'campaign_fr_ymd',
          'campaign_to_ymd',
          'client_nm',
          'agency_nm',
          'lab_cust_nm'
        ],
        viewCnt: 20
      }
    },
    components: {
      Dashboard,
      HeaderComp,
      Result,
      Pagination
    },
    methods: {
      ...mapMutations([
        'setCurrentCampaign',
        'setCurrentPageNum',
        'setListStatus',
        'setOrderType',
        'setSearchKey',
        'setSortKey',
        'sortCampaignList'
      ]),
      campaignClick (campaign) {
        this.selected_cam = campaign
        if (checkCampaignYmd(campaign.campaign_fr_ymd)) { // 현재 날짜, 캠페인 시작날짜 비교
          this.setCampaign()
        } else {
          alert('캠페인이 시작된 후 다음날부터 데이터를 확인할 수 있습니다.')
        }
      },
      isSorted (value) { // 입력 키 값으로 리스트 정렬여부
        return this.listSortKey === value
      },
      pageChange (pNum) {
        this.setCurrentPageNum(pNum)
        window.scroll(0, 0)
        document.body.scrollTop = 0
      },
      setCampaign () { // store의 currentCampaign에 저장 후 캠페인 코드, 이름 sessio storage에 저장 -> 새로고침시 데이터 유지 위해
        this.setCurrentCampaign(this.selected_cam)
        let campaign = {
          nm: this.selected_cam.campaign_nm,
          cd: this.selected_cam.campaign_cd
        }

        campaign = btoa(encodeURIComponent(JSON.stringify(campaign)))
        sessionStorage.setItem('iw_c', campaign)
        this.$router.push('/campaign')
      },
      setSortOption (e) { // 리스트 정렬 기준 설정
        if (e.target.getAttribute('value') === null) { // 정렬 키 값 초기화
          this.setSortKey('campaign_fr_ymd')
          this.setOrderType('desc')
          return
        }

        if (this.listSortKey !== e.target.getAttribute('value')) { // 이전 정렬 기준과 다른 키값이 오면 변경
          this.setSortKey(e.target.getAttribute('value'))
          this.setOrderType('asc')
          return
        }
        this.setOrderType((this.listOrderType === 'asc') ? 'desc' : 'asc') // 정렬 키값 같으면 순서(asc, desc)만 변경
      },
      updateSearchKey (e) { // 검색 키워드 설정
        let filterKey = e.target.value
        if (this.lastSearchKey !== filterKey) { this.pageChange(1) } // 기존 검색 키워드와 다시 확인한 키워드 다를 시 1페이지로 이동
        let keyword = filterKey && filterKey.toLowerCase()
        this.setSearchKey(keyword) // store에 키워드 저장 - 캠페인 상세 조회후 뒤로가기했을때 검색 정보 유지 위해서
      }
    },
    computed: {
      ...mapGetters({
        searchList: 'getSearchList'
      }),
      ...mapState([
        'campaignListStatus',
        'currentPage',
        'getStatus',
        'listOrderType',
        'listSortKey'
      ]),
      ...mapState({
        lastSearchKey: 'searchKey'
      }),
      cust_knd () { // 사용자 타입 - 리스트 표시할 내용 구분 위해 사용
        return checkUser(this.user)
      },
      filteredCampaign: function () { // 검색,정렬된 캠페인 리스트
        this.sortCampaignList() // 저장된 키워드, 정렬기준으로 캠페인 정렬, 검색 실행
        let res = this.searchList(this.viewCnt) // 검색,정렬된 캠페인 리스트 데이터

        if (res.info !== 0 || this.getStatus === true) { // 받은 리스트 수 0 || ajax 완료시 로딩표시 숨김
          this.isLoading = false
          this.noData = false
        }
        if (res.info === 0 && this.getStatus === true) this.noData = true // 받은 리스트 수 0 -> 데이터 없음 표시

        this.totalCnt = res.info // pagination위한 총 결과 수
        return res.data
      },
      isShow () {
        return this.noData
      },
      selected: { // 상태 선택 select box와 store의 캠페인 상태 연결
        get () { // store에서 가저옴
          return statusText(this.campaignListStatus)
        },
        set (value) { // 선택된 값을 store에 적용
          this.pageChange(1)
          let status
          switch (value) {
            case '전체':
              status = 0
              break
            case '진행':
              status = 2
              break
            case '홀딩':
              status = 3
              break
            case '완료':
              status = 4
              break
            case '중간정산':
              status = 5
              break
            default: break
          }
          this.setListStatus(status)
        }
      },
      totalPageNum () {
        return this.totalCnt % this.viewCnt === 0
        ? parseInt(this.totalCnt / this.viewCnt) : parseInt(this.totalCnt / this.viewCnt) + 1
      }
    },
    created () {
      if (!isLogin()) { // 로그인 여부 체크
        this.$router.push('/')
      } else {
        this.isLoading = true
        let data = JSON.parse(decodeURIComponent(atob(sessionStorage.getItem('iw_u'))))
        this.user = data.cust_knd // 로그인 되어있으면 사용자 타입 확인 위해 knd저장
      }
    },
    mounted () {
      document.body.scrollTop = 0
    }
  }
</script>

<style scoped>
  .noData {
    width: 100%;
    text-align: center;
    font-weight: 500;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eee;
  }
  .topBar {
    position: relative;
    margin-bottom: .5em;
    height: 25px;
  }
  .topBar div {
    position: absolute;
  }
  .dataCnt {
    vertical-align: middle;
  }
  .selectWrap {
    left: 0;
  }
  .searchWrap {
    right: 1px;
  }
  .selectBox {
    width: 80px;
    padding-bottom:3px; 
    height: 25px;
    border-radius: 6px;
    margin-right: 5px;
    border: 1px solid #cbdde7;
  }
  .selectBox:focus {
    outline: none;
  }
  .searchIcon {
    vertical-align: middle;
    font-weight: bold;
    color: #1c5900
  }
  .searchInput {
    width: 250px;
    border-radius: 5px;
    border: 1px solid #cbdde7;
    height: 20px;
  }
  .tableWrapper {
    min-width: 710px; /* 임시 */
    background: #fff;
    padding: 5px 10px 0;
    border-radius: 8px;
    /* margin-bottom: 10px; */
    border: 1px solid #cbdde7;
  }
  .table_header i {
    position: absolute;
    right: 0;
    vertical-align: middle;
    font-size: 25px;
    font-weight: 600;
    color: #8bc34a;
    padding-top: 2px;
  }
  .arrow_desc, .arrow_asc {
    font-size: 15px !important;
    color:#bebebe !important;
  }
  .arrow_desc {
    top: 9px;
  }
  .arrow_asc {
    top: 3px;
  }
  table {
    border-collapse: collapse;
    width: 100%;
  }
  tr {
    height: 31px;
    border-bottom: 1px solid #cee3f0;
  }
  .resultView.odd {
    background: #f6fbfc;
  }

  .paginationWrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .loading {
    top: 0;
    left: 150px;
    position: fixed;
    width: calc(100% - 150px);
    height: 100%;
    z-index: 999;
  }
  .loading div {
    width: 150px;
    height: 150px;
    margin-left: calc(50% - 100px);
    margin-top: 150px;
    text-align: center;
  }
  .loading div img {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 800px) {
    .tableWrapper {
      min-width: 0;
      width: calc(100% - 12px);
      padding-left: 0;
      padding-right: 0;
      margin-left: auto;
      margin-right: auto;
    }
    .selectWrap {
      left: 5px;
    }
    .searchWrap {
      right: 5px;
    }
    .odd {
      background: #fff !important;
    }
    .loading {
      left: 0;
      width: 100%;
    }
    .loading div {
      width: 80px;
      height: 80px;
      margin-left: calc(50% - 40px);
    }
  }
  @media screen and (max-width: 600px) {
    .searchInput {
      width: 200px;
    }
    .tableWrapper {
      margin-bottom: 10px;
    }
  }
  @media screen and (max-width: 420px) {
    .searchInput {
      width: 130px !important;
    }
  }
  @media screen and (max-width: 350px) {
    .searchIcon {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// ResultList.vue?36e388f3